module.exports = __webpack_public_path__ + "img/paper_plane.5df33ffd.svg";